import api from "./api";

export const walletService = {
  // Get wallet balance
  getBalance: async () => {
    const response = await api.get("/wallet/balance");
    return response.data;
  },

  // Initiate deposit
  initiateDeposit: async (depositData) => {
    const response = await api.post("/wallet/deposit", depositData);
    return response.data;
  },

  // Verify OTP for deposit
  verifyOtp: async (otpData) => {
    const response = await api.post("/wallet/verify-otp", otpData);
    return response.data;
  },

  // Check deposit status
  checkStatus: async (depositRef) => {
    const response = await api.get(`/wallet/status?deposit_ref=${depositRef}`); // ✅ Correct
    return response.data;
  },

  // Get transaction history
  getHistory: async (limit = 20, offset = 0) => {
    const response = await api.get(
      `/wallet/history?limit=${limit}&offset=${offset}`,
    );
    return response.data;
  },
};
